import React, { useEffect, useRef, useState } from 'react';
import { stats } from '../../data/mockData';
import './Stats.css';

const DURATION = 1400;

const useCountUp = (target, start) => {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!start) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setValue(target);
      return;
    }

    let frame;
    const begin = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - begin) / DURATION, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(Math.round(target * eased));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [target, start]);

  return value;
};

const StatNumber = ({ raw, start }) => {
  const prefix = raw.replace(/[0-9]/g, '');
  const target = parseInt(raw.replace(/\D/g, ''), 10) || 0;
  const value = useCountUp(target, start);
  return <div className="stat-number">{prefix}{value}</div>;
};

const Stats = () => {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
          observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="stats-section" ref={sectionRef} data-testid="stats-section">
      <div className="container">
        <h6 className="stats-label">Nos chiffres</h6>
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="stat-card glass fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
              data-testid={`stat-card-${index}`}
            >
              <StatNumber raw={stat.number} start={inView} />
              <div className="stat-label">{stat.label}</div>
              {stat.sublabel && <div className="stat-sublabel">{stat.sublabel}</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
